import axios from "axios";

export const loadAllContactAPI = (payload) => {
  return axios
    .get(
      `${payload.dataURL}?limit=${payload.pageSize}&page=${
        payload.currentPage
      }&countries=[${payload.selectedCountries}]&orderBy=${
        payload.sort ? payload.sort.dir : "desc"
      }&status=${payload.status}&platformUser=${
        payload.platformUser
      }&companyId=${payload.companyId}&orderColumn=${
        payload.sort ? payload.sort.column : "id"
      }&search=${payload.search ?? ""}&dependancies=${payload?.dependancies}`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    )
    .then((res) => res.data);
};

export const loadSingleContactAPI = (payload) => {
  return axios
    .get(`/contacts/${payload.contactId}`, {
      headers: {
        Accept: "application/json",
      },
    })
    .then((res) => res.data);
};
